(function () {
  'use strict';

  function init(root) {
    var tabs = root.querySelector('[data-sd-tabs]');
    if (!tabs) return;

    var filterAttr = 'data-sd-filter';
    var allButtons = tabs.querySelectorAll('button[' + filterAttr + ']');
    var cards = root.querySelectorAll('.d1-sd__card[data-sd-state]');

    function setActive(filter) {
      allButtons.forEach(function (btn) {
        var f = btn.getAttribute(filterAttr);
        var isOn = f === filter;
        btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        btn.setAttribute('data-active', isOn ? 'true' : 'false');
      });
      cards.forEach(function (card) {
        var s = card.getAttribute('data-sd-state') || '';
        if (filter === 'all' || s === filter) {
          card.hidden = false;
        } else {
          card.hidden = true;
        }
      });
    }

    allButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var f = btn.getAttribute(filterAttr);
        if (f) setActive(f);
      });
    });

    var initial = root.getAttribute('data-sd-initial') || 'all';
    setActive(initial);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-d1-store-directory]').forEach(init);
  });
})();
